import { useParams, Navigate } from "react-router-dom";
import { ALL_LOCATIONS, LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";
import ChineseBlogPage from "./ChineseBlogPage";

const RegionBlogPageZh = () => {
  const { region } = useParams<{ region: string }>();

  const locationData = ALL_LOCATIONS.find(loc => loc.slug === region || loc.regionSlug === region);

  if (!locationData) return <Navigate to="/zh/blog" replace />;

  return (
    <LocationContext.Provider value={locationData}>
      <WaitlistPopup />
      <ChineseBlogPage />
    </LocationContext.Provider>
  );
};

export default RegionBlogPageZh;